// extracted by mini-css-extract-plugin
export var tocpicsGobackBtn = "by_d5";
export var topicsFilterContainer = "by_d3";
export var topicsFilterWrapper = "by_d4";